<template>
  <div class="container">
    <h1 class="subs-title">{{ organizationText(getTitle()) }}</h1>
    <text-field v-model="form.name" :validator="$v.form.name" :label="adminText('organizationAll.membership_name_98b14ff5', 'Membership name*')" />
    <div class="input-container">
      <datetime-field
        v-model="form.from"
        :validator="$v.form.from"
        style="width: 100%"
        :label="adminText('organizationAll.from_4a2da276', 'From*')"
        :min="new Date().toString()"
        :error-messages="{
          minDate: adminText('organizationAll.start_date_must_be_a_future_date_49b63d67', 'Start date must be a future date'),
          maxDate: adminText('organizationAll.start_date_should_be_before_the_end_of_the_ev_d4de23c0', 'Start date should be before the end of the event'),
        }"
      />
      <datetime-field
        v-model="form.to"
        :validator="$v.form.to"
        style="width: 100%"
        :label="adminText('organizationAll.to_c2fdddd0', 'To*')"
        :min="form.from ? form.from.toString() : new Date().toString()"
        :error-messages="{
          minDate: adminText('organizationAll.end_date_should_not_be_before_the_start_of_th_0753b659', 'End date should not be before the start of the event'),
        }"
      />
    </div>
    <div class="input-container">
      <text-field
        v-model.number="form.price"
        :validator="$v.form.price"
        type="number"
        step="0.01"
        :label="adminText('organizationAll.price_eur_444903ee', 'Price (EUR)*')"
      />
    </div>
    <select-field-multiple
      v-if="!excludeOrderItemTemplates"
      v-model="form.orderItemTemplates"
      :label="adminText('organizationAll.choose_ticket_type_7a282743', 'Choose Ticket type*')"
      :items="orderItemTemplates"
      item-render="name"
      item-select="id"
      :validator="$v.form.orderItemTemplates"
    />
    <p
      v-if="!excludeOrderItemTemplates"
      class="ticket-type-note"
      :style="$v.form.orderItemTemplates.$invalid && 'margin-top: -1.5rem'"
    >
      {{ adminText('organizationAll.if_the_ticket_type_is_not_on_the_list_check_i_8d41144e', 'If the Ticket type is not on the list, check if it is marked as Membership only.') }}
    </p>
    <div v-if="!excludeOrderItemTemplates" class="input-container">
      <text-field
        v-model.number="form.amount"
        :validator="$v.form.amount"
        type="number"
        step="1"
        :label="adminText('organizationAll.amount_of_tickets_301ea606', 'Amount of Tickets*')"
      />
      <text-field disabled :placeholder="adminText('organizationAll.per_every_included_month_a288937e', 'Per every included month')" :label="adminText('organizationAll.available_9a6a014b', 'Available*')" />
    </div>
    <cover-field
      v-if="includeCoverImageField"
      v-model="form.imageUrl"
      :validator="$v.form.imageUrl"
    />
    <textarea-field
      v-model="form.description"
      :validator="$v.form.description"
      :label="adminText('organizationAll.description_55f8ebc8', 'Description')"
      height="13.75rem"
    />
    <div class="buttons-wrapper" style="margin-top: 58px">
      <main-button :text="adminText('organizationAll.cancel_1507c40f', 'CANCEL')" flat depressed @click="$emit('cancel')" />
      <div class="buttons">
        <main-button :text="organizationText(buttonName)" @click="handleCreate" />
      </div>
    </div>
  </div>
</template>

<script>
import OrganizationLocalization from '@/components/organizations/organization-all-display'

import { required, requiredIf, maxLength } from 'vuelidate/lib/validators'
import {  submitGuard } from '@/utils'

export default {
  mixins: [OrganizationLocalization],
  name: 'create-or-edit-membership',
  components: {},
  props: {
    initialValue: {
      type: Object,
      default: () => {},
    },
    orderItemTemplates: {
      type: Array,
      default: () => [],
    },
    excludeOrderItemTemplates: {
      type: Boolean,
      default: () => false,
    },
    includeCoverImageField: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      form: { ...this.initialValue },
      buttonName: 'Create plan',
      emitType: 'create',
      attendeeFields: {},
    }
  },
  validations() {
    return {
      form: {
        name: { required },
        price: { required },
        from: { required },
        to: { required },
        amount: { required: requiredIf(() => !this.excludeOrderItemTemplates) },
        orderItemTemplates: { required: requiredIf(() => !this.excludeOrderItemTemplates) },
        imageUrl: { required: requiredIf(() => this.includeCoverImageField) },
        description: { maxLength: maxLength(255) },
      },
    }
  },
  methods: {
    getTitle() {
      if (Object.keys(this.initialValue).length) {
        this.buttonName = 'Update'
        this.emitType = 'update'

        return 'Edit Membership Plan'
      } else {
        return 'Create a new Membership Plan'
      }
    },
    handleCreate() {
      submitGuard(this, () => this.$emit(this.emitType, this.form))
    },
  },
}
</script>

<style scoped>
.ticket-type-note {
  font-family: Roboto;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1rem;
  color: #666;
  text-indent: 1rem;
  margin-top: -2.5rem;
}
.container {
  padding: 0 !important;
  margin: 0 !important;
  display: flex;
  flex-direction: column;
  max-width: 43.75rem;
  row-gap: 2rem;
}
.subs-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
  margin-bottom: 1.5rem;
}
.input-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
  column-gap: 1.5rem;
}
</style>
